var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1597)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_1597)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_1597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57551 1H9.40303C7.35505 1 5.69482 2.65949 5.69482 4.70657V8.2599C5.69482 10.307 7.35505 11.9665 9.40303 11.9665H9.57551C11.6235 11.9665 13.2837 10.307 13.2837 8.2599V4.70657C13.2837 2.65949 11.6235 1 9.57551 1Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.70508 5.8463C7.00822 5.8463 8.41677 5.81757 8.57966 4.24683C8.35928 6.35392 12.0866 5.8463 13.2844 5.8463",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68506 9.00684C8.68506 9.00684 9.43245 9.64854 10.1894 9.00684",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98523 23H4.02789C2.35105 23 1 21.7358 1 20.1746V19.8968C1 16.3627 4.0758 13.4894 7.87025 13.4894V11.9761",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93213 19.801H10.3999C11.2911 19.801 12.0193 20.4906 12.0193 21.3526V21.4484C12.0193 22.3008 11.2911 23 10.3999 23H4.48788",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68506 19.801V23",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2947 14.064C9.71974 14.1885 8.89569 14.1406 7.86084 13.4797",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1758 11.9664V13.0679",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5972 20.1363C11.5972 19.3797 12.0571 18.7284 12.7183 18.4124",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6626 18.259C18.5729 18.441 19.2628 19.2072 19.2628 20.1363V22.0901C19.2628 22.5882 18.8412 22.9904 18.3238 22.9904H12.7471C12.335 22.9904 11.9805 22.7893 11.7793 22.4828",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3153 20.8068C15.8815 20.8068 16.3406 20.3694 16.3406 19.8298C16.3406 19.2903 15.8815 18.8529 15.3153 18.8529C14.7491 18.8529 14.29 19.2903 14.29 19.8298C14.29 20.3694 14.7491 20.8068 15.3153 20.8068Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1496 12.7519C13.1496 12.7519 10.1025 12.6465 10.1025 15.4049C10.1025 16.7554 11.0128 17.1864 12.1435 16.6021",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8676 12.3114C16.0244 11.8325 14.6733 11.8421 13.8493 12.3114C12.5078 13.0776 12.0958 15.2517 12.2395 16.6118C12.4024 18.1825 13.8589 18.7955 15.3632 18.853C16.8676 18.7955 18.3241 18.1825 18.4869 16.6118C18.6307 15.2517 18.2091 13.0776 16.8772 12.3114H16.8676Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5283 12.7519C17.5283 12.7519 20.5754 12.6465 20.5754 15.4049C20.5754 16.7554 19.6651 17.1864 18.5344 16.6021",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6213 15.8837H15.008C14.6058 15.8837 14.2798 16.2096 14.2798 16.6116C14.2798 17.0136 14.6058 17.3395 15.008 17.3395H15.6213C16.0234 17.3395 16.3495 17.0136 16.3495 16.6116C16.3495 16.2096 16.0234 15.8837 15.6213 15.8837Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3149 16.7745V18.8529",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5852 7.12019C20.2594 6.88074 18.228 5.62607 18.228 4.40012V4.1511C18.228 3.45193 18.8029 2.88684 19.512 2.88684H19.5599C20.0007 2.88684 20.3935 3.10713 20.6235 3.44235",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5852 7.12009C20.2594 6.88065 18.228 5.62597 18.228 4.40002",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6428 7.12019C20.9686 6.88074 23 5.62607 23 4.40012V4.1511C23 3.45193 22.4251 2.88684 21.716 2.88684H21.6681C21.2273 2.88684 20.8345 3.10713 20.6045 3.44235",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6426 7.12009C20.9684 6.88065 22.9997 5.62597 22.9997 4.40002",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_1597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_1597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.a6447d66c51d83b3c9920310ef1e7507.svg";
export { ForwardRef as ReactComponent };